import React from "react";
import {Select, Tag, Typography} from "antd"

const {Text} = Typography

export default class PaiementMethodDataField extends React.Component {
    render() {

        const {edit, propertie, value, onChange, form} = this.props

        const paiementMethods = form?.paiementMethods || []

        console.log(form)

        if (!edit || paiementMethods.length === 0) {
            const paiementMethod = value || "En Ligne"
            return (
                <Tag color={"purple"}>{paiementMethod}</Tag>
            )
        }

        const defaultValue = value || "En Ligne"

        return (
            <Select defaultValue={defaultValue} onChange={(v) => onChange(v)}>
                <Select.Option value={"En Ligne"}>En Ligne</Select.Option>
                {paiementMethods.map(i => {
                    return (
                        <Select.Option value={i}>{i}</Select.Option>
                    )
                })}
            </Select>
        )

    }
}
